import * as React from 'react'

function SvgPeopleFilterIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.165 2.833H9.832l4.327 6.498v3.597l2.798 2.183-.086-5.78 4.294-6.498zM10.756 11.444a2.756 2.756 0 11-5.51 0 2.756 2.756 0 015.51 0zM13.335 22.11c0-2.454-2.388-4.444-5.334-4.444-2.945 0-5.333 1.99-5.333 4.444"
        stroke="#222"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgPeopleFilterIcon
